import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HistoryComponent } from './history/history.component';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { SparePartHistoryComponent } from './spare-part-history/spare-part-history.component';
import { SparePartModalComponent } from './spare-part-modal/spare-part-modal.component';
import { StatusChangerComponent } from '../status-changer/status-changer.component';
import { AddSparePartComponent } from '../add-spare-part/add-spare-part.component';
import { OrdersService } from '../../services/orders/orders.service';
import { SparePartsService } from '../../services/spareParts/spare-parts.service';
import { ExportedFoldersService } from '../../services/exported-folders/exported-folders.service';
import { AuthService } from '../../services/auth/auth.service';
import { LabelsService } from '../../services/labels/labels.service';

@NgModule({
  declarations: [
    HistoryComponent,
    OrderHistoryComponent,
    SparePartHistoryComponent,
    SparePartModalComponent,
    StatusChangerComponent,
    AddSparePartComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  exports: [
    HistoryComponent,
    OrderHistoryComponent,
    SparePartHistoryComponent,
    SparePartModalComponent,
    StatusChangerComponent,
    AddSparePartComponent
  ],
  providers: [
    OrdersService,
    SparePartsService,
    ExportedFoldersService,
    AuthService,
    LabelsService
  ]
})
export class HistoryModule { } 